import { AbilityBuilder, Ability } from '@casl/ability'

export default function defineAbilitiesFor(user) {
  const { can, cannot, rules } = new AbilityBuilder();

  // super admin rules
  if (user.super_admin) {
    cannot('read', 'all')
    can('manage', 'Company')
  }

    // admin only
  if (user.admin) {
    can('import', 'Loads')
    can('import', 'Clients')
    can('import', 'Localities')
    can('import', 'Products')
    can('import', 'Vehicles')
  }
  
  // except for super_admin
  if (user.admin && !user.super_admin || !user.admin && !user.super_admin) {
    can('view', 'all')
    can('read', 'all')
    cannot('read', 'Company')
  }
  return new Ability(rules);
} 